<div class="page-content">
  <app-equipamentos-nav [currentType]="'utensilios'" [currentTotal]="navTotal" />

  <div class="equipment-view-tabs" role="tablist" aria-label="Vista de utens&iacute;lios">
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'list'"
      (click)="activeSection = 'list'">
      <i class="ri-archive-line"></i> Invent&aacute;rio
    </button>
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'configuration'"
      (click)="activeSection = 'configuration'">
      <i class="ri-settings-3-line"></i> Configura&ccedil;&atilde;o
    </button>
  </div>


  <!-- KPIs -->
  <div class="equip-tab active">
    <div class="inner-panel active" *ngIf="activeSection === 'list'">
      <app-equipamento-kpi-grid [items]="kpiItems" [columns]="3" />

      <p-menu #rowMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

      <!-- FILTER BAR -->
      <div class="table-actions-row" style="justify-content: flex-end;">
        <button type="button" class="btn-web-primary" (click)="openCreateDrawer()">
          <i class="fas fa-plus"></i> Registar Utensílio
        </button>
      </div>


      <div class="data-table-wrapper">
        <div *ngIf="loading" class="skeleton-rows">
          <p-skeleton height="48px" *ngFor="let i of [1, 2, 3, 4, 5, 6]" styleClass="mb-2"></p-skeleton>
        </div>

        <div *ngIf="!loading">
          <app-empty-state
            *ngIf="filteredEquipamentos.length === 0"
            icon="pi pi-warehouse"
            appearance="orbit"
            title="Nenhum utensílio registado"
            message="Os utensílios registados serão apresentados aqui. Utilize “Registar Utensílio” no topo para adicionar o primeiro."
          >
          </app-empty-state>

          <table class="data-table" *ngIf="filteredEquipamentos.length > 0">
            <thead>
              <tr>
                <th class="equipment-photo-heading">Utensílio</th>
                <th>Nome / Categoria</th>
                <th>Marca / Modelo</th>
                <th>Qtd</th>
                <th>Posto</th>
                <th>Data Aquisição</th>
                <th>Valor</th>
                <th>Ativo</th>
                <th>Estado</th>
                <th class="text-right">Acções</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of filteredEquipamentos" class="clickable-row" (click)="verDetalhe(e)">
                <td class="equipment-photo-column">
                  <div class="equip-thumb equip-thumb--large" [ngClass]="getEstadoClass(e.estado) || 'badge-default'">
                    <app-equipment-photo
                      [src]="e.fotoUrl"
                      alt="Fotografia do utensílio"
                      fallbackIcon="pi pi-warehouse"
                    />
                  </div>
                </td>
                <td>
                  <span class="equip-modelo">
                    {{ getPropriedadeValor(e, "NOME") || getPropriedadeValor(e, "NOME_ITEM") || "—" }}
                    <span *ngIf="getPropriedadeValor(e, 'CATEGORIA')">
                      · {{ getPropriedadeValor(e, "CATEGORIA") }}</span>
                  </span>
                </td>
                <td>
                  <span class="equip-modelo">
                    {{ getPropriedadeValor(e, "MARCA") || "—" }}
                    <span *ngIf="getPropriedadeValor(e, 'MODELO')">
                      · {{ getPropriedadeValor(e, "MODELO") }}</span>
                  </span>
                </td>
                <td>{{ e.quantidade || 0 }}</td>
                <td class="col-posto">
                  <div class="posto-box" *ngIf="getPostoAtribuido(e) !== '—'; else semPosto">
                    <i class="ri-map-pin-2-line"></i>
                    <span> {{ getPostoAtribuido(e) }}</span>
                  </div>
                  <ng-template #semPosto>
                    <span class="text-muted-dash">—</span>
                  </ng-template>
                </td>
                <td>
                  {{ e.dataAquisicao ? (e.dataAquisicao | date:'dd/MM/yyyy') : "—" }}
                </td>
                <td>{{ e.valorAquisicao ? (e.valorAquisicao | currency:'AOA':'symbol':'1.2-2') : '—' }}</td>
                <td>
                  <span class="badge" [ngClass]="e.ativo ? 'badge-bom' : 'badge-inativo'">
                    {{ e.ativo ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="getEstadoClass(e.estado)">{{
                    getEstadoLabel(e.estado)
                    }}</span>
                </td>
                <td class="actions" (click)="$event.stopPropagation()">
                  <button class="btn-dots" (click)="openRowMenu($event, e)">
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="equipment-pagination" *ngIf="totalRecords > 0">
            <app-paginator-control
              [first]="pageFirst"
              [rows]="pageSize"
              [totalRecords]="totalRecords"
              [rowsPerPageOptions]="[10, 20, 50]"
              (pageChange)="onPageChange($event)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="inner-panel active configuration-panel-host" *ngIf="activeSection === 'configuration'">
      <app-tipos-equipamento [embedded]="true" [presetTipoId]="3" />
    </div>
  </div>

<p-drawer [(visible)]="showCreateDrawer" position="right" [modal]="true" [blockScroll]="true"
    header="Registar Novo Utensílio" styleClass="equip-create-drawer">
    <app-novo-equipamento *ngIf="showCreateDrawer" [drawerMode]="true" [presetTipoId]="3"
      (closed)="showCreateDrawer = false" (saved)="onEquipmentSaved()"
      [IdCategoriaEquipamento]="IdCategoriaEquipamento" />
  </p-drawer>
</div>
